import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Box, Collapse, List } from "@mui/material";
import { ReactNode, useState } from "react";

import SidebarItem from "./SidebarItem";

interface SidebarCollapsibleProps {
  icon: ReactNode;
  label: string;
  expanded: boolean;
  onExpandSidebar: () => void;
  children: ReactNode;
}

const SidebarCollapsible = ({
  icon,
  label,
  expanded,
  onExpandSidebar,
  children,
}: SidebarCollapsibleProps) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    if (!expanded) {
      onExpandSidebar();
      setOpen(true);
    } else {
      setOpen(!open);
    }
  };

  return (
    <>
      <SidebarItem
        icon={icon}
        label={label}
        expanded={expanded}
        onClick={handleClick}
      >
        <Box flex={2}>
          {expanded && (open ? <ExpandLess /> : <ExpandMore />)}
        </Box>
      </SidebarItem>

      <Collapse in={open && expanded} timeout="auto" unmountOnExit>
        <List>{children}</List>
      </Collapse>
    </>
  );
};

export default SidebarCollapsible;
